const equipmentList = {
  "belongs-to": "Pertenece A",
  "v-card-title": "Activos",
  plantList: "Áreas",
  operations: "Estatus de Operaciones",
  "label-search": "Buscar",
  "span-equipment-profile": "Perfil de Equipo",
  "span-statitics": "Gráficas",
  "span-inspections-list": "Revisar Inspecciones de este equipo",
  "span-new-inspections": "Nueva Inspeccion",
  "span-repair-list": "Revisar Registro de reparaciones de este equipo",
  "span-new-repair-logs": "Registrar nueva reparacion",
  equipImg: "Imagen de Equipo",
  equipTag: "Tag del Equipo",
  status: "Estatus de Confiabilidad",
  equipType: "Tipo de Equipo",
  customer: "Compañia",
  area: "Area",
  plant: "Planta",
  unit: "Unidad",
  profile: "Perfil",
  statitics: "Gráficas",
  inspections: "Inspección",
  reliability: "Confiabilidad",
  "repair-logs": "Reparación",
  scanAndInspect: "Escanea e Inspecciona",
  reportError: "Soporte Técnico",
  cancel: "Cancelar",
  pilot: "DEV",
  scanQR: "Escaneo de QR",
  running: "En Servicio",
  zones: {
    zone: "Zona",
    smooth: "Optimo",
    warning: "Advertencia",
    alarm: "Alarma"
  }
};

export default equipmentList;
